// extracted by mini-css-extract-plugin
export default {"gptAd":"cpm-ad-target-for-modal-ad-target-for-modal__gptAd--tfNIg","centered":"cpm-ad-target-for-modal-ad-target-for-modal__centered--27tU1"};